import { fetcher } from '@commenda/utils';

const deleteBusinessEntityLocation = async (
  businessEntityId: number,
  locationId: string
) => {
  const response = await fetcher(
    `business-entities/${businessEntityId}/locations/${locationId}`,
    { method: 'DELETE' }
  );

  return response;
};

export { deleteBusinessEntityLocation };
